import React from 'react';

import cn from '../../../lib/classNames';
import SectionHeader from '../SectionHeader/SectionHeader';

import care from './images/care.png';
import health from './images/health.png';
import risk from './images/risk.png';

import styles from './ProtectYourPeople.module.scss';

type ItemType = {
	imageSrc: string;
	altText: string;
	description: string;
};

function Item({ imageSrc, altText, description }: ItemType) {
	return (
		<div className={styles.item}>
			<div className={styles.image}>
				<img src={imageSrc} alt={altText} />
			</div>
			<div className={styles.description}>{description}</div>
		</div>
	);
}

type ProtectYourPeopleType = {
	classPageContent?: string;
};

const ProtectYourPeople = React.forwardRef<HTMLDivElement, ProtectYourPeopleType>((props, ref) => {
	const { classPageContent } = props;
	return (
		<div ref={ref} className={cn(styles.wrap, classPageContent)}>
			<SectionHeader
				title="Protect Your People Anywhere They Go"
				subTitle="Increase organizational resilience while ensuring each employee receives the personalized guidance they need, whether traveling domestically or internationally"
			/>
			<div className={styles.items}>
				<Item
					imageSrc={health}
					altText="health"
					description="Improve your team’s health, safety and security with personalized risk intelligence"
				/>
				<Item
					imageSrc={risk}
					altText="risk"
					description="Enhance personal and managerial risk & safety decision quality"
				/>
				<Item
					imageSrc={care}
					altText="care"
					description="Fulfill your Duty of Care and meet risk management best practices"
				/>
			</div>
		</div>
	);
});

ProtectYourPeople.displayName = 'ProtectYourPeople';

export default ProtectYourPeople;
